import React from "react";
import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import { tw } from "@careinfo/tailwind";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/Endpoint";
const CreateHubComponent = loadable(
  () => import("../../components/Hub/CreateHub")
);
const CreateHub = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["hub"],
    navigateURL: "/",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.HUB}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Create Hub</span>
      </div>
      <CreateHubComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </>
  );
};

export default CreateHub;
